<template>
    <span>
        <v-chip
            v-if="account.type === 'group'"
            pill
            color="grey lighten-3"
            :close="closable"
            @click="members_dialog = true"
            @click:close="$emit('remove', account.person_id)"
        >
            <AccountGroupMembersDialog
                v-if="members_dialog"
                :show-dialog="members_dialog"
                :group-id="account.person_id"
                :base-url="baseUrl"
                @close="members_dialog = false"
            ></AccountGroupMembersDialog>
            <v-avatar left color="primary" class="uku-group-avatar">
                <span class="subtitle-2 white--text">
                    {{ account.initials }}
                </span>
            </v-avatar>
            {{ account.name }}
        </v-chip>
        <v-chip v-else pill color="grey lighten-3" :close="closable" @click:close="$emit('remove', account.person_id)">
            <v-avatar left :color="account.avatar ? 'white' : 'grey lighten-2'">
                <img v-if="account.avatar" :alt="account.initials" :src="baseUrl + account.avatar" />
                <span v-else class="subtitle-2 blue-grey--text text--darken-1">
                    {{ account.initials }}
                </span>
            </v-avatar>
            {{ account.name }}
            <v-avatar v-if="showIsPrimary" right>
                <icon-button
                    :color="isPrimary ? 'primary' : ''"
                    icon-size="18"
                    :icon="isPrimary ? 'StarFilled' : 'Star'"
                    @click="$emit('set_primary', account.person_id)"
                />
            </v-avatar>
        </v-chip>
    </span>
</template>

<script>
import { ref } from "@vue/composition-api";
import AccountGroupMembersDialog from "../components/AccountGroupMembersDialog.vue";

export default {
    name: "AccountChip",
    components: {
        AccountGroupMembersDialog
    },
    props: {
        baseUrl: {
            type: String,
            required: true
        },
        account: {
            type: Object,
            required: true
        },
        showIsPrimary: {
            type: Boolean,
            default: false
        },
        isPrimary: {
            type: Boolean,
            default: false
        },
        closable: {
            type: Boolean,
            default: false
        },
    },
    setup() {
        const members_dialog = ref(false);

        return {
            members_dialog
        };
    }
};
</script>
